import React, { useState } from 'react'

// Components
import Modal from 'components/Modal'
import { Button } from '@sketch/components'

// Hooks
import { useToast } from '@sketch/toasts'
import { useDeletePersonalToken } from '../../operations'

// Types
import { PersonalTokenFragment } from '@sketch/gql-types'
import { ModalInjectedProps } from 'containers/ModalManager'

interface DeleteTokenConfirmationModalProps extends ModalInjectedProps {
  token: PersonalTokenFragment
}

const DeleteTokenConfirmationModal: React.FC<DeleteTokenConfirmationModalProps> = props => {
  const { token, hideModal } = props
  const { showToast } = useToast()
  const truncatedDescription =
    token.description.length < 30
      ? token.description
      : `${token.description.slice(0, 29)}...`

  const deleteToken = useDeletePersonalToken({
    onCompleted: () => {
      hideModal()
      const message = `“${truncatedDescription}” successfully deleted`
      showToast(message)
    },
  })

  const [loading, setLoading] = useState(false)

  const handleConfirmDeleteClick = async () => {
    setLoading(true)
    await deleteToken({ identifier: token.identifier })
    setLoading(false)
  }

  return (
    <Modal title="Delete this Token?" onCancel={hideModal}>
      <Modal.Body>
        Deleting “{token.description}” will instantly revoke access from all
        applications that use it.
        <br />
        <br />
        You can always create more personal access tokens.
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={hideModal} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleConfirmDeleteClick}
          disabled={loading}
          variant="negative"
        >
          Delete Token
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DeleteTokenConfirmationModal
